// extracted by mini-css-extract-plugin
export default {"root":"styles_root__mtAlQ","element":"styles_element__zGZJ0","caption":"styles_caption__ihOcU","value":"styles_value__bmjhk"};